import { CONTENT_REPORT_STATUS } from '../../constants/supportTicket'

export default function ReportTicketStatus({ status }) {
  const statusContent = CONTENT_REPORT_STATUS[status.toLowerCase()] || {}

  if (!statusContent.label) return

  return (
    <span className={statusContent.className + ' px-2 py-1 rounded-lg text-xs font-medium'}>
      {statusContent.label}
    </span>
  )
}
